export var DeliveryPlatformKind;
(function (DeliveryPlatformKind) {
    DeliveryPlatformKind[DeliveryPlatformKind["ChromeLike"] = 5] = "ChromeLike";
    DeliveryPlatformKind[DeliveryPlatformKind["Safari"] = 7] = "Safari";
    DeliveryPlatformKind[DeliveryPlatformKind["Firefox"] = 8] = "Firefox";
    DeliveryPlatformKind[DeliveryPlatformKind["Email"] = 11] = "Email";
    DeliveryPlatformKind[DeliveryPlatformKind["Edge"] = 12] = "Edge";
    DeliveryPlatformKind[DeliveryPlatformKind["SMS"] = 14] = "SMS";
})(DeliveryPlatformKind || (DeliveryPlatformKind = {}));
//# sourceMappingURL=DeliveryPlatformKind.js.map